'use client';

import { c as _c } from "react/compiler-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@icons/classic/regular';
import { clsxm } from '../utils';
import { Badge } from './Badge';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import type { BadgeProps } from './Badge';
export interface DismissibleBadgeProps extends Omit<BadgeProps, 'children' | 'asChild'> {
  /** Text shown in the badge. */
  label: string;
  /** Removes the badge. */
  onDismiss: () => void;
  /** Icon rendered before the label. */
  icon?: IconDefinition;
  /** Accessible name of the dismiss button. Defaults to `Remove {label}`. */
  dismissLabel?: string;
}

/** A badge carrying a value the user can drop, e.g. an applied filter or a linked record. */
export function DismissibleBadge(t0) {
  const $ = _c(21);
  let className;
  let dismissLabel;
  let icon;
  let label;
  let onDismiss;
  let props;
  if ($[0] !== t0) {
    ({
      label,
      onDismiss,
      icon,
      dismissLabel,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = dismissLabel;
    $[3] = icon;
    $[4] = label;
    $[5] = onDismiss;
    $[6] = props;
  } else {
    className = $[1];
    dismissLabel = $[2];
    icon = $[3];
    label = $[4];
    onDismiss = $[5];
    props = $[6];
  }
  let t1;
  if ($[7] !== className) {
    t1 = clsxm("gap-1 pr-1 pl-2", className);
    $[7] = className;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== icon) {
    t2 = icon && <FontAwesomeIcon className="text-content-tertiary" icon={icon} />;
    $[9] = icon;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const t3 = dismissLabel ?? `Remove ${label}`;
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FontAwesomeIcon className="text-content-tertiary hover:text-content" icon={faXmark} />;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== onDismiss || $[13] !== t3) {
    t5 = <button className="rounded-full p-0.5 leading-none hover:bg-background-tertiary" aria-label={t3} onClick={onDismiss} type="button">{t4}</button>;
    $[12] = onDismiss;
    $[13] = t3;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== label || $[16] !== props || $[17] !== t1 || $[18] !== t2 || $[19] !== t5) {
    t6 = <Badge className={t1} {...props}>{t2}{label}{t5}</Badge>;
    $[15] = label;
    $[16] = props;
    $[17] = t1;
    $[18] = t2;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
}